var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPhotoGallery(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "22px",
    viewBox: "0 0 27 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPhotoGallery") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeOpacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Community-On-the-ground-gallery-Desktop",
    transform: "translate(-433.000000, -430.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(123.000000, 206.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-37",
    transform: "translate(20.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(2.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-43",
    transform: "translate(-5.000000, -5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-58",
    transform: "translate(4.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(280.000000, 152.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icPhotoGallery"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7793842,19.6322032 L2.76075752,19.6322032 C1.23816202,19.6322032 0,18.3940412 0,16.8714457 L0,2.76075752 C0,1.23816196 1.23816202,0 2.76075752,0 L21.7793842,0 C23.3019798,0 24.5401417,1.23816196 24.5401417,2.76075752 L24.5401417,16.8714457 C24.5401417,18.3940412 23.3019798,19.6322032 21.7793842,19.6322032 Z M2.76075752,1.84050501 C2.25277635,1.84050501 1.84050501,2.2527763 1.84050501,2.76075752 L1.84050501,16.8714457 C1.84050501,17.3794269 2.25277635,17.7916982 2.76075752,17.7916982 L21.7793842,17.7916982 C22.2873654,17.7916982 22.6996367,17.3794269 22.6996367,16.8714457 L22.6996367,2.76075752 C22.6996367,2.2527763 22.2873654,1.84050501 21.7793842,1.84050501 L2.76075752,1.84050501 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.17749118,8.61748172 C4.82407295,8.61748172 3.7234096,7.51681837 3.7234096,6.16340013 C3.7234096,4.8099819 4.82407295,3.7093186 6.17749118,3.7093186 C7.53090942,3.7093186 8.63134812,4.8099819 8.63134812,6.16340013 C8.63134812,7.51681837 7.53090942,8.61748172 6.17749118,8.61748172 Z M6.17749118,5.54982362 C5.83868728,5.54982362 5.56391461,5.82482095 5.56391461,6.16340013 C5.56391461,6.50197938 5.83868728,6.77697671 6.17749118,6.77697671 C6.51607043,6.77697671 6.7908431,6.50197938 6.7908431,6.16340013 C6.7908431,5.82482095 6.51607043,5.54982362 6.17749118,5.54982362 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.21996436,16.7729033 C1.92667855,16.4703597 1.92667855,15.9796719 2.21996436,15.6771284 L6.7448146,11.0094488 C7.42963697,10.3030096 8.54375644,10.3030096 9.22747902,11.0094488 L10.4378329,12.2580082 L14.1557805,7.6542409 C14.48811,7.24315983 14.9756976,7.00566315 15.4933471,7.00263772 C16.0498569,6.97068157 16.5004173,7.2318145 16.8356796,7.63779008 L21.8191555,13.6355267 C22.0893451,13.9598156 22.0523177,14.4493689 21.737952,14.7280871 C21.4226698,15.0069944 20.9491965,14.9687983 20.6788236,14.6445094 L15.6935147,8.64469284 C15.6273421,8.56300609 15.5463219,8.56716604 15.5012292,8.55260614 C15.4583361,8.55260614 15.3751163,8.56603152 15.309127,8.64658372 L11.064548,13.9030887 C10.9292699,14.070244 10.7322185,14.1715961 10.5219693,14.1808615 C10.3076873,14.1931523 10.1055034,14.1084401 9.95721077,13.9547102 L8.16541774,12.1061691 C8.03820504,11.9749408 7.93317202,11.9749408 7.80595932,12.1061691 L3.28110913,16.7729033 C3.13483281,16.9245532 2.9427306,17 2.7504451,17 C2.55834289,17 2.36605739,16.9245532 2.21996436,16.7729033 Z",
    id: "Path",
    strokeWidth: 0.8
  }))))))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhotoGallery);
export default __webpack_public_path__ + "static/media/icPhotoGallery.de74a1a074420d181963d4048f55ad96.svg";
export { ForwardRef as ReactComponent };